/* eslint-disable standard/object-curly-even-spacing */
/* eslint-disable camelcase */
import Multiselect from 'vue-multiselect'
import apiCus from '../../../services/service_customer'
import apiCalendar from '../../../services/service_calendar'
import moment from 'moment'

export default {
  props: ['host', 'hodingOrder'],
  components: {
    Multiselect
  },
  data () {
    return {
      payment_amount: 0,
      customer_data: [],
      customer: '',
      header: {
        headers: {
          'Access-Token': sessionStorage.token
        }
      },
      description: '',
      calendar_time: moment(new Date()),
      calendar_description: '',
      auto_day: 0,
      status_gentime: false
    }
  },
  methods: {
    moment,
    changeDay (val) {
      this.auto_day = val
      this.calendar_time = moment(new Date()).add(val, 'days')
    },
    customSearch ({ ar_code, cus_name}) {
      return `${ar_code}: ${cus_name}`
    },
    setArcode () {
      this.$store.state.order_data.ar_code = this.customer.ar_code
      // alert(JSON.stringify(this.customer))
    },
    getCustomer () {
      this.$store.commit('Loading')
      let body = {
        keyword: '',
        limit: 1000000,
        status: 1
      }
      apiCus.listAll(
        this.REST_URL,
        this.header,
        body,
        result => {
          if (result.response === 'success') {
            this.customer_data = []
            result.data.forEach(val => {
              this.customer_data.push({
                cus_name: val['name'],
                ar_code: val['code']
              })
              if (this.$store.state.order_data.holding_status === 1) {
                if (this.$store.state.order_data.ar_code === val['code']) {
                  this.customer = {
                    cus_name: val['name'],
                    ar_code: val['code']
                  }
                }
              } else {
                this.customer = {
                  cus_name: 'เงินสด',
                  ar_code: '99999'
                }
                setTimeout(() => {
                  this.setArcode()
                }, 200)
                if (this.$refs.cusAuto) {
                  this.$refs.cusAuto.inputValue = ''
                }
              }
            })
          } else {
            this.$notification['warning']({
              message: 'ดึงข้อมูลลูกหนี้',
              description: result.message
            })
          }
          this.$store.commit('Loading')
        },
        error => {
          alert('ไม่สามารถเข้าถึงข้อมูล ' + JSON.stringify(error))
        }
      )
    },
    confirm () {
      console.log('heelo')
      if (this.calendar_description || (this.status_gentime === true && this.customer)) {
        if (!this.calendar_description) {
          this.calendar_description = '-'
        }
        this.addCalendar({
          id: 0,
          title: 'H' + this.auto_day + '(' + this.customer.cus_name + ') ' + this.dateFormatDMY(new Date()) + ' ' + this.calendar_description,
          start: this.calendar_time
        })
      }
    },
    testdata () {
      alert(JSON.stringify(this.customer))
    },
    addCalendar (data) {
      if (data.title !== '') {
        const obj = {
          'id': data.id,
          'title': data.title,
          'start': moment(data.start).format('YYYY-MM-DD HH:mm:ss'),
          'color': 'yellow',
          'all_day': false
        }
        if (obj.id === 0) {
          obj.status = 0
        } else {
          obj.status = 1
        }
        apiCalendar.new(
          this.REST_URL,
          {
            headers: {
              'Access-Token': sessionStorage.token
            }
          },
          obj,
          result => {
            if (result.response === 'success') {
              this.$notification['success']({
                message: 'ข้อมูลการนัดหมาย',
                description:
                  'จัดการข้อมูลการนัดหมายสำเร็จ!!'
              })
            } else {
              this.$notification['warning']({
                message: 'จัดการข้อมูลปฎิทิน',
                description:
                  result.message
              })
            }
          },
          error => {
            alert('ไม่สามารถเข้าถึงข้อมูล ' + JSON.stringify(error))
          }
        )
      } else {
        this.$notification['warning']({
          message: 'เพิ่มข้อมูลปฎิทิน',
          description:
            'ไม่มีข้อมูล'
        })
      }
    }
  },
  mounted () {
    this.getCustomer()
    $('#PaymentModal').on(
      'show.bs.modal',
      function () {
        this.getCustomer()
      }.bind(this)
    )
    $('#PaymentModal').on(
      'hidden.bs.modal',
      function () {
        this.payment_amount = 0
        this.customer = ''
      }.bind(this)
    )
  }
}



// WEBPACK FOOTER //
// ./src/assets/js/pos/holdingbill.js